export default __webpack_public_path__ + "static/artifakt-legend-medium-dc6e1e887c71d920d039435b9c7f3bb9.woff2";